module.exports = __webpack_public_path__ + "img/pic3.612c53f7.png";